module.exports = __webpack_public_path__ + "static/img/249_TO8_2234.94ba098.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/249_TO8_2234.jpg
// module id = Jdtb
// module chunks = 0